import React from 'react'
import { shouldOpenInNewTab, getRelAttribute } from '../../util'
import styles from './Link.module.css'

type LinkProps = {
  href: string
  target?: React.HTMLAttributeAnchorTarget
  children: React.ReactNode
  className?: string
}

function Link(props: LinkProps) {
  // Determine if this link should open in a new tab
  const shouldOpenNewTab = props.target === '_blank' || shouldOpenInNewTab(props.href)
  const finalTarget = shouldOpenNewTab ? '_blank' : props.target
  
  // Get the appropriate rel attribute
  const rel = getRelAttribute(props.href, finalTarget)
  
  // Combine custom className with default styles
  const className = props.className ? `${styles.link} ${props.className}` : styles.link

  return (
    <a 
      href={props.href} 
      target={finalTarget} 
      rel={rel} 
      className={className}
    >
      {props.children}
    </a>
  )
}

export { Link }
